import { render } from "./SaleOrdersView.vue?vue&type=template&id=2bcd947e&scoped=true"
import script from "./SaleOrdersView.vue?vue&type=script&lang=js"
export * from "./SaleOrdersView.vue?vue&type=script&lang=js"

import "./SaleOrdersView.vue?vue&type=style&index=0&id=2bcd947e&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1078960470/src/pricing_engine_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bcd947e"]])

export default __exports__